export default {
    "attachments": {
        "extensions": [
            "txt",
            "docx",
            "doc",
            "xls",
            "xlsx",
            "rar",
            "zip",
            "jpg",
            "jpeg",
            "png",
            "pdf"
        ]
    },
    "comment_entity_types_enum": "app\\build\\smz\\Comment\\enums\\SmzCommentEntityTypesEnum"
}